import EntertainmentCard from './EntertainmentCard';

interface Entertainment {
  name: string;
  category: string;
  distance: string;
  image: string;
  alt: string;
  description: string;
  highlights: string[];
  openingHours: string;
}

interface EntertainmentSectionProps {
  className?: string;
}

const EntertainmentSection = ({ className = '' }: EntertainmentSectionProps) => {
  const entertainmentOptions: Entertainment[] = [
  {
    name: 'Bannerghatta National Park',
    category: 'Nature & Wildlife',
    distance: '5 km',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1711999ed-1782747612710.png",
    alt: 'Lush green forest landscape with wildlife in Bannerghatta National Park',
    description: 'Explore diverse wildlife, butterfly park, and safari experiences in this sprawling biological reserve.',
    highlights: [
    'Lion and tiger safari experiences',
    'Butterfly conservatory with 100+ species',
    'Nature trails and trekking paths',
    'Zoo and rescue center visits'],

    openingHours: '9:30 AM - 5:00 PM (Closed on Tuesdays)'
  },
  {
    name: 'Nexus Vega City Mall',
    category: 'Shopping & Entertainment',
    distance: '1.7 km',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_186832be1-1782637521378.png",
    alt: 'Nexus Vega City Mall interior with multiple floors, bright lighting and shoppers on Bannerghatta Road Bangalore',
    description: "South Bengaluru's vibrant lifestyle destination with top fashion brands, SPAR Hypermarket, PVR Cinema, and a buzzing food court — all just 1.7 km away.",
    highlights: [
    'SPAR Hypermarket for daily groceries',
    'PVR SuperFlex multiplex cinema',
    'H&M, Lifestyle, Toys"R"Us & more',
    'FunCity Arcade & food court with 20+ options'],

    openingHours: '11:00 AM - 10:00 PM (Daily)'
  },
  {
    name: 'Turahalli Forest',
    category: 'Adventure & Nature',
    distance: '7 km',
    image: "https://images.unsplash.com/photo-1647568915657-c237b6fea460",
    alt: 'Dense forest trail with sunlight filtering through trees',
    description: 'Urban forest perfect for mountain biking, rock climbing, and nature walks amidst rocky terrain.',
    highlights: [
    'Mountain biking trails',
    'Rock climbing opportunities',
    'Bird watching and photography',
    'Sunrise and sunset viewpoints'],

    openingHours: '6:00 AM - 6:00 PM (Daily)'
  },
  {
    name: 'Art of Living International Center',
    category: 'Wellness & Spirituality',
    distance: '12 km',
    image: "https://images.unsplash.com/photo-1606178839515-d3aa7abac476",
    alt: 'Peaceful meditation center with white architecture and gardens',
    description: 'Serene ashram offering meditation programs, yoga sessions, and spiritual retreats in tranquil surroundings.',
    highlights: [
    'Meditation and yoga programs',
    'Vedic temple and prayer halls',
    'Organic vegetarian restaurant',
    'Wellness workshops and courses'],

    openingHours: '6:00 AM - 8:00 PM (Daily)'
  },
  {
    name: 'Innovative Film City',
    category: 'Theme Park & Studios',
    distance: '35 km',
    image: "https://images.unsplash.com/photo-1634299570775-25f609e09339",
    alt: 'Colorful theme park with rides and entertainment attractions',
    description: 'Entertainment complex near Bidadi featuring film studios, theme park rides, and cultural shows for all ages.',
    highlights: [
    'Film studio tours and sets',
    'Amusement park rides',
    'Wax museum and 4D theater',
    'Cultural shows and performances'],

    openingHours: '10:30 AM - 7:00 PM (Daily)'
  },
  {
    name: 'Jayanagar Shopping Complex',
    category: 'Local Shopping',
    distance: '8 km',
    image: "https://images.unsplash.com/photo-1716461917098-5292fb2b097d",
    alt: 'Bustling local market with colorful shops and street vendors',
    description: 'Traditional shopping area known for silk sarees, jewelry, and authentic South Indian products.',
    highlights: [
    'Silk sarees and traditional wear',
    'Gold and silver jewelry shops',
    'Local handicrafts and artifacts',
    'Street food and snack stalls'],

    openingHours: '10:00 AM - 9:00 PM (Daily)'
  }];


  return (
    <section className={`py-16 lg:py-24 bg-background ${className}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-text-primary mb-4">
            Entertainment & Leisure
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            From wildlife adventures to shopping destinations, discover diverse entertainment options that make your stay memorable beyond business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {entertainmentOptions.map((option, index) =>
          <EntertainmentCard key={index} {...option} />
          )}
        </div>
      </div>
    </section>);

};

export default EntertainmentSection;